import { Routes} from '@angular/router';
import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { SigninRedirectCallbackComponent } from './starter/signin-redirect-callback.component';
import { SignoutRedirectCallbackComponent } from './starter/signout-redirect-callback.component';
import { AuthRouteGuard } from '../app/core/auth-route-guard';
import { Applications } from './applications/applications.component';
import { LoginComponent } from './authentication/login/login.component';
export const Approutes: Routes = [
  { path: 'signin-callback', component: SigninRedirectCallbackComponent },
  { path: 'signout-callback', component: SignoutRedirectCallbackComponent },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren:
          () => import('./authentication/authentication.module').then(m => m.AuthenticationModule)
      }
    ]
  },  
  {
    path: '',  
    children: [
      { path: 'dashboard', component: FullComponent, loadChildren:() => import('./starter/starter.module').then(m => m.StarterModule), canActivate: [AuthRouteGuard]},
      { path: 'webresolution', component: FullComponent, loadChildren:() => import('./webresolution/webres.module').then(m => m.WebresolutionModule), canActivate: [AuthRouteGuard]},
      { path: 'eDataNew', component: FullComponent, loadChildren:() => import('./e-data-new/e-data-new.module').then(m => m.EDataNewModule),canActivate: [AuthRouteGuard]},
      { path: 'rules', component: FullComponent, loadChildren:() => import('./rules/rule.module').then(m => m.RuleModule),canActivate: [AuthRouteGuard]}, 
      // { path: 'imagearchive', loadChildren:() => import('./imagearchive/imagearchive.module').then(m => m.ImageArchiveModule),canActivate :[AuthRouteGuard]},
      { path: 'ratesearch', component: FullComponent, loadChildren:() => import('./multirater/multirater.module').then(m => m.MultiRaterModule), canActivate: [AuthRouteGuard]},
      { path: 'webstore', component: FullComponent, loadChildren: () => import('./webstore/webstore.module').then(m => m.WebstoreModule), canActivate: [AuthRouteGuard]},
      { path: 'newwebstore', component: FullComponent, loadChildren: () => import('./webstorenew/webstore.module').then(m => m.WebstoreModule), canActivate: [AuthRouteGuard]},
      { path: 'eData', component: FullComponent, loadChildren:() => import('./e-data/e-data.module').then(m => m.EDataModule), canActivate: [AuthRouteGuard]},
      { path: 'newimagearchive', component: FullComponent, loadChildren:() => import('./newimagearchive/newimagearchive.module').then(m => m.NewImageArchiveModule),canActivate: [AuthRouteGuard]},
      { path: 'ctms', component: FullComponent, loadChildren:() => import('./ctms/ctms.module').then(m => m.CtmsModule)},
      { path: 'rate-document', component: FullComponent, loadChildren:() => import('./ratedocument/rate-document.module').then(m => m.RateDocumentModule)}
    ]
  },
  { path: 'applications', component: Applications},
  {
    path: 'error',
    component: FullComponent,
    loadChildren: () => import('./error/error.module').then(m => m.ErrorModule)
  },
  { 
    path: '**',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren:
          () => import('./authentication/authentication.module').then(m => m.AuthenticationModule)
      }
    ]
  },
];